// extracted by mini-css-extract-plugin
export default {"options":"ResultTableTab_options__QA71D","option":"ResultTableTab_option__tkkH7","active":"ResultTableTab_active__miYZ4"};